// storageVersionCheck.js
// Manages localStorage versioning to handle breaking changes in data structure

const CURRENT_VERSION = '2.2'; // Increment this for breaking changes
const VERSION_KEY = 'STORAGE_VERSION';

// Keys to clear when version changes (data with structure dependencies)
const KEYS_TO_CLEAR = [
  'mock_devices_data',    // Orphaned mock devices from old code
  'mock_flows_data'       // Orphaned mock flows from old code
];

/**
 * Check storage version and clear outdated data if needed
 * Call this early in the app lifecycle (e.g., in App.js)
 */
export const checkStorageVersion = () => {
  const storedVersion = localStorage.getItem(VERSION_KEY);

  // If version doesn't exist or doesn't match current version
  if (storedVersion !== CURRENT_VERSION) {
    console.log(`Storage version mismatch. Stored: ${storedVersion}, Current: ${CURRENT_VERSION}`);
    console.log('Clearing outdated localStorage data...');

    // Clear outdated data
    KEYS_TO_CLEAR.forEach(key => {
      if (localStorage.getItem(key)) {
        console.log(`  - Removing ${key}`);
        localStorage.removeItem(key);
      }
    });

    // Set new version
    localStorage.setItem(VERSION_KEY, CURRENT_VERSION);
    console.log(`Storage version updated to ${CURRENT_VERSION}`);
  } else {
    console.log(`Storage version ${CURRENT_VERSION} is current`);
  }
};

/**
 * Get current storage version
 */
export const getStorageVersion = () => {
  return localStorage.getItem(VERSION_KEY) || 'unknown';
};

/**
 * Manually clear all versioned data (for debugging)
 */
export const clearVersionedData = () => {
  KEYS_TO_CLEAR.forEach(key => {
    localStorage.removeItem(key);
  });
  localStorage.removeItem(VERSION_KEY);
  console.log('All versioned data cleared');
};
